import useScrollReset from 'src/utils/hooks/useScrollReset';

const ScrollReset = () => {
  useScrollReset();

  return null;
};

export default ScrollReset;
